import React from 'react';

const Loading = () => {
    return (
        <div className="loader">loading</div>
    );
};

export default Loading;